import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import {
  JobTopBar,
  JobTopBarActions,
  JobTopBarChatButton,
} from '@/features/jobs/details/components/JobTopBar'
import { CallChipContainer } from '@/features/jobs/details/components/JobTopBar/CallChip/CallChipContainer'
import { type JobActionsViewModel } from '@/features/jobs/details/JobActionsViewModel'
import { JobActionsMenuItems } from '@/features/jobs/details/components/JobActionsMenuItems'

export interface JobTopBarContainerProps {
  vm: JobDetailsViewModel
  onJobListSidebarToggle?: () => unknown
  onJobListHoverChange: (isHovering: boolean) => unknown
  isJobListSidebarVisible: boolean
  onPreviousJob?: () => unknown
  onNextJob?: () => unknown
}

export const JobTopBarContainer = observer(function JobTopBarContainer({
  vm,
  onJobListSidebarToggle,
  onJobListHoverChange,
  isJobListSidebarVisible,
  onPreviousJob,
  onNextJob,
}: JobTopBarContainerProps) {
  return (
    <JobTopBar
      title={vm.heading.title}
      shortId={vm.job.shortId}
      isDetailsOpen={vm.detailsOpen}
      onDetailsToggle={vm.toggleDetails}
      callChip={<CallChipContainer vm={vm} />}
      chatButton={<JobTopBarChatButtonContainer vm={vm} />}
      actions={<JobTopBarActionsContainer vm={vm.actionsVm} />}
      onJobListSidebarToggle={onJobListSidebarToggle}
      onJobListHoverChange={onJobListHoverChange}
      isJobListSidebarVisible={isJobListSidebarVisible}
      onPreviousJob={onPreviousJob}
      onNextJob={onNextJob}
    />
  )
})

interface JobTopBarSlotContainerProps {
  vm: JobDetailsViewModel
}

const JobTopBarChatButtonContainer = observer(
  function JobTopBarChatButtonContainer({ vm }: JobTopBarSlotContainerProps) {
    if (!vm.canChat) {
      return null
    }

    return (
      <JobTopBarChatButton
        isOpen={vm.isChatOpen}
        unreadCount={vm.conversationVm.unreadCount}
        onPress={vm.toggleChat}
      />
    )
  },
)

interface JobTopBarActionsContainerProps {
  vm: JobActionsViewModel
}

const JobTopBarActionsContainer = observer(function JobTopBarActionsContainer({
  vm,
}: JobTopBarActionsContainerProps) {
  if (vm.menuSections.length === 0) {
    return null
  }

  return (
    <JobTopBarActions>
      <JobActionsMenuItems sections={vm.menuSections} />
    </JobTopBarActions>
  )
})
